// @flow
import React, { Component } from "react";
import Link from "gatsby-link";
import ArrowLeft from "react-feather/dist/icons/arrow-left";
import SocialShare from "./SocialShare/SocialShare";
import styles from "./BreachHero.module.css";

type Props = {
  breach: PrismicBreach
};

type State = {};

class BreachHero extends Component<Props, State> {
  render() {
    const { breach } = this.props;
    const { data } = breach;
    return (
      <div className={styles.wrapper}>
        <Link to="/" className={styles.back}>
          <ArrowLeft /> back to breaches overview
        </Link>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <h1 className={styles.title}>{data.title.text}</h1>
          </div>
          <div className={styles.heroLinks}>
            <SocialShare className={styles.social} breach={breach} />
            <div className={styles.heroSource}>
              <span className={styles.sourceLabel}>Source</span>
              <a
                href={data.source_url.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.sourceLink}
              >
                {data.source_url.url}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BreachHero;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachHero/BreachHero.js